import React from 'react';
import '../style.css';

interface TextInputProps {
  name?: string;
  placeholder: string;
  value?: string;
  setValue?: (value: string) => void;
  width?: string | number;
  height?: string | number;
  disabled?: boolean;
  isNotValid?: boolean;
}



export const TextInput: React.FC<TextInputProps> = (props) => {
  const { name, placeholder, value, setValue, width, height, disabled, isNotValid } = props;
  return (
    <div 
      className='generic-text-input'
      style={{
        width: width ? width : '100%',
        height: height ? height : '100%',
      }}
    >
      {name && <div className='generic-text-input__label'>{name}</div>}
      <input
        name={name}
        className={isNotValid ? 'generic-text-input__input generic-input_not-valid' : 'generic-text-input__input'}
        placeholder={placeholder}
        value={value}
        onChange={(e: any) => {
          if (setValue) {
            setValue(e.target.value);
          }
        }}
        disabled={disabled}
      />
    </div>
  );
};
